<script>
import { mapActions } from 'vuex'
import ModalFormMixin from '@lib/mixins/modal-form'
import amountMask from '@lib/utils/amount-mask'

export default {
  name: 'SupplierEditModal',
  mixins: [ModalFormMixin],
  props: {
    supplier: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      progress: false,
      form: {
        name: null,
        active: false,
        currency: 'AUD',
        fulfillment_email: null,
        sales_tax_rate: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        fulfillment_email: [
          {
            required: true,
            message: 'This field is required',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Must be a valid email address',
            trigger: ['blur', 'change'],
          },
        ],
        sales_tax_rate: [{
          required: true,
          message: 'This field s required',
        }],
      },
    }
  },
  computed: {
    isCreate() {
      return !Object.keys(this.supplier).length
    },
    title() {
      return `${this.isCreate ? 'Create' : 'Edit'} Supplier`
    },
    status() {
      return `Supplier ${this.form.active ? 'Available' : 'Not Available'}`
    },
  },
  created() {
    if (!this.isCreate) {
      const { form } = this
      const {
        name,
        active,
        sales_tax_rate: taxRate,
        fulfillment_email: email,
      } = this.supplier

      form.name = name
      form.active = active
      form.fulfillment_email = email
      form.sales_tax_rate = taxRate
    }
  },
  methods: {
    amountMask,
    ...mapActions('suppliers', ['createSupplier', 'updateSupplier']),
    async onSubmit() {
      const formValid = await this.$refs.form.validate().catch(() => false)
      if (!formValid) {
        return
      }

      const action = this.isCreate ? 'createSupplier' : 'updateSupplier'

      this.progress = true
      const [error, response] = await this[action]({
        supplierId: this.supplier.id || null,
        form: this.form,
      })
      this.progress = false

      this.$notifier({
        response: [error, response],
        successMsg: `Supplier successfuly ${
          this.isCreate ? 'created' : 'updated'
        }`,
      })

      if (response) {
        this.$emit('update:visible', false)
        this.$modal.self.hide()
        if (this.isCreate) {
          this.$router.push({
            name: 'supplier-details',
            params: { id: response.id },
          })
        }
      }
    },
  },
}
</script>

<template>
  <base-modal
    :title="title"
    :check-form-changes="form"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      :disabled="progress"
      :rules="rules"
    >
      <el-form-item
        label="Supplier Name"
        prop="name"
      >
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="Currency">
        <el-input
          v-model="form.currency"
          disabled
        />
      </el-form-item>

      <el-form-item
        label="Tax Rate"
        prop="sales_tax_rate"
        :class="$style.taxRate"
      >
        <el-input
          :value="form.sales_tax_rate"
          @input="form.sales_tax_rate = amountMask($event)"
        >
          <template
            #append
          >
            %
          </template>
        </el-input>
      </el-form-item>


      <el-form-item
        label="Fulfillment Email"
        prop="fulfillment_email"
      >
        <el-input
          v-model="form.fulfillment_email"
        />
      </el-form-item>
      <el-form-item v-if="isCreate">
        <el-switch
          v-model="form.active"
          active-color="#13ce66"
          inactive-color="#a7a7a7"
        />
        <span
          :class="$style.status"
          :style="{ color: `${form.active ? '#13ce66' : '#a7a7a7'}` }"
        >
          {{ status }}
        </span>
      </el-form-item>
      <el-button
        type="primary"
        :class="$style.button"
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Save
      </el-button>
    </el-form>
  </base-modal>
</template>

<style lang="scss" module>
.button {
  display: block;
  margin-right: auto;
  margin-left: auto;
}

.status {
  margin-left: rem(14px);
}

.taxRate {
  width: calc(50% - 1rem) !important
}
</style>
